// @flow
import React from 'react';
import type {Node} from 'react';
import {OutlinedInput} from '@mui/material';
import {Select} from '@wellstone-solutions/web';
import {
  RECURRENCE_FREQ_MAP,
  frequencySelectItems,
} from 'modules/calendar/constants';

type PropsType = {
  items?: Array<{label: string, value: string}>,
  disabled?: boolean,
  onChange: (string) => void,
  value?: string,
};

export const FreqSelect = ({
  items = frequencySelectItems,
  disabled = false,
  onChange,
  value,
}: PropsType): Node => {
  const augmentedValue =
    value && value.length > 0 ? value : RECURRENCE_FREQ_MAP.daily;

  return (
    <Select
      data-testid="freq-select"
      disabled={disabled}
      canUnselect={false}
      onChange={(e) => onChange(e.target.value)}
      input={<OutlinedInput notched={false} />}
      items={items}
      value={augmentedValue}
      containerProps={{
        sx: {
          minWidth: 120,
        },
      }}
      inputProps={{sx: {backgroundColor: '#FFF'}}}
    />
  );
};
